import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../lib/api";
import { useUserLocation, locParams, locLabel } from "../lib/location";
import DealerCard from "../components/DealerCard";
import BackButton from "../components/BackButton";

export default function Dealers() {
  const { location } = useUserLocation();
  const [q, setQ] = useState("");
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const lp = locParams(location);
  const key = JSON.stringify(lp);
  useEffect(() => {
    let stale = false;
    setLoading(true);
    axios.get(`${API}/dealers`, { params: { ...lp, ...(q ? { q } : {}) } }).then((r) => !stale && setList(r.data)).catch(() => !stale && setList([])).finally(() => !stale && setLoading(false));
    return () => { stale = true; };
  }, [key, q]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-28" data-testid="dealers-page">
      <BackButton className="mb-4" />
      <p className="eyebrow mb-2">Pre-owned car dealers · {location?.state ? locLabel(location) : "All India"}</p>
      <h1 className="font-display text-4xl sm:text-5xl mb-3">Dealer Stores</h1>
      <p className="text-gray-400 max-w-2xl mb-6 text-sm">Visit showrooms near you. Every store shows its logo, address and live inventory. Change your location from the top bar.</p>
      <div className="lux-card p-4 grid sm:grid-cols-3 gap-3 mb-6">
        <div><label className="lux-label">Dealer name</label><input className="lux-input" placeholder="Search dealers" onKeyDown={(e) => e.key === "Enter" && setQ(e.target.value)} onBlur={(e) => setQ(e.target.value)} data-testid="dealers-search-input" /></div>
      </div>
      <p className="text-sm text-gray-400 mb-4" data-testid="dealers-count">{loading ? "Loading..." : `${list.length} dealer stores`}</p>
      {!loading && !list.length && <div className="lux-card p-12 text-center text-gray-400" data-testid="dealers-empty">No dealer stores in {locLabel(location) === "Select city" ? "this area" : locLabel(location)} yet.</div>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">{list.map((d) => <DealerCard key={d.id} dealer={d} />)}</div>
    </div>
  );
}
